/* eslint-disable */
import * as types from './mutation-types'

export default {
  [types.SET_NG_WORDS] (state, words) {
    state.ngWords = words
  },
  [types.SET_UNREAD_FINEPLAY_APPROVE] (state, fineplays) {
  	let count = 0
  	fineplays.map(fineplay => {
  		if (fineplay.can_approve)
  			count++
  		})
    state.numberUnReadFineplayApprove = count
  },
  [types.SET_NOTIFICATIONS] (state, notifications) {
    state.notifications = notifications
  },
  [types.ADD_NGWORD] (state, ngWord) {
    state.ngWords = [...state.ngWords, ngWord]
  },
  [types.UPDATE_NGWORD] (state, ngWord) {
    const index = state.ngWords.findIndex(n => n.id === ngWord.id)
    if (index !== -1) {
      state.ngWords[index] = ngWord
    }
  },
  [types.DELETE_NGWORD] (state, ngWord) {
    const index = state.ngWords.findIndex(n => n.id === ngWord.id)
    if (index !== -1) {
      state.ngWords.splice(index)
    }
  },
  [types.SET_TOTAL_NOT_COMPLETE_SURVEY] (state, count) {
    state.numberSurveyNotComplete = count.total_not_complete
  },
  [types.COMPLETE_SURVEY] (state) {
    if (state.numberSurveyNotComplete) {
      state.numberSurveyNotComplete = state.numberSurveyNotComplete - 1
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/masterData/mutations.js